var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4998",
    d: "M8.78192 0.499999C4.60221 0.499999 1.20447 3.85269 1.20447 8C1.20447 12.1473 4.60221 15.5 8.78192 15.5C12.9616 15.5 16.3594 12.1473 16.3594 8C16.3594 3.85269 12.9616 0.5 8.78192 0.499999Z",
    fill: "#6951FF",
    fillOpacity: 0.05,
    stroke: "#780EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1145",
    d: "M12.3203 9.75L8.78159 6.25L5.24286 9.75",
    stroke: "#780EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.d26c77c0da6f364fe3cdfbeb07373556.svg";
export { ForwardRef as ReactComponent };